import React from 'react';
import { MultiSelectDropdown } from 'components/MultiSelectDropdown/MultiSelectDropdown';
import SingleSelectDropdown from './components/SingleSelectDropdown/index';

const FilterOptionsButton = props => {
  const { type, children } = props;
  if (type === 'singleOption') {
    return <SingleSelectDropdown {...props} />;
  }
  return <MultiSelectDropdown {...props}>{children}</MultiSelectDropdown>;
};

export default FilterOptionsButton;
